import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

console.log("%c🚀 ImobGo Agency Portal", "color: #3B82F6; font-size: 20px; font-weight: bold;");
console.log("📍 Mode:", import.meta.env.MODE);
console.log("🛠️ Mock Agency:", import.meta.env.VITE_MOCK_AGENCY);
console.log("🛠️ Mock Auth:", import.meta.env.VITE_MOCK_AUTH);

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("❌ Critical: Root element not found!");
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
